export default {
  props: {
    default: Object
  },
  data () {
    return {
      note: null
    }
  },
  computed: {
    noteStyle () {
      return { display: this.note !== null ? 'block' : 'none' }
    }
  },
  methods: {
    addNote () {
      this.$emit('note', { note: '' })
    }
  },
  watch: {
    note (next, prev) {
      if (next === '' && prev === null) {
        return
      }
      this.$emit('note', { note: next || null })
    }
  }
}
